<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import FileApi from '@/api/common/file';
import MapAPI from '@/api/topologymap/common';
import WEventPredict from '@/views/event/event-predict';

export default {
  name: 'WTopologymapEventPredict',
  extends: WEventPredict,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler() {
        if (this.active === false) {
          this.clear();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active) {
        return;
      }
      const histParams = this.getListParameters();
      this.$nextTick(() => {
        const tableParams = this.$refs.predictTable.getParameter();
        const params = {
          ...tableParams,
          ...histParams,
          mapId: this.$store.getters.getCurrentMapId,
        };
        MapAPI.getPredictEventHist(params).then((response) => {
          if (response.data.success) {
            this.predictTableData = response.data.data;
          }
        });
      });
    },
    exportExcel() {
      const histParams = this.getListParameters();
      const tableParams = this.$refs.predictTable.getParameter();
      const params = {
        ...tableParams,
        ...histParams,
        mapId: this.$store.getters.getCurrentMapId,
      };
      MapAPI.getPredictEventInfoExcelName(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
    clear() {
      this.isLoading = false;
      this.showSearchTool = false;
      this.total = 0;
      this.predictTaskFlag = true;
      this.selectedRows = [];
      this.histParams = {};
      this.eventHistSeqNumbers = [];
      this.predictTableData = [];
    },
  },
};
</script>
<style lang="scss">
.topologymap-event-popup {
  .el-tabs__tool {
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapEventPredict.vue